<template>
  <div class="modal-msg" :class="{ show: show }">
    <p class="message">{{ msg }}</p>
  </div>
</template>

<script>
export default {
  name: "ModalConfirm",
  props: ["msg", "show"],
};
</script>

<style lang="scss" scoped>
.modal-msg {
  width: 300px;
  height: 60px;
  z-index: 50;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.4);
  position: fixed;
  font-size: 0.875rem;
  justify-content: center;
  align-items: center;
  top: 15%;
  z-index: 1000;
  background: #1d1d1d;
  display: none;
  left: 50%;
  transition: all 0.3s;
}

.message {
  text-align: center;
  color: #fff;
}

.show {
  animation: show 0.3s forwards;
  display: flex;
  opacity: 1;
  z-index: 1000;
}

@keyframes show {
  from {
    display: none;
    transform: translate3d(-50%, -10%, 0);
    opacity: 0;
  }
  to {
    display: flex;
    transform: translate3d(-50%, -15%, 0);
    opacity: 1;
  }
}
</style>
